import React from "react";
import { cn } from "../lib/utils";

export const HeartHandIcon = React.forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement>
>((props, ref) => {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      strokeWidth="1"
      className={cn("w-5", props.className)}
      {...props}
      ref={ref}
    >
      <g clipPath="url(#clip0_2939_9142)">
        <path
          d="M12.6673 9.33333C13.6607 8.36 14.6673 7.19333 14.6673 5.66667C14.6673 4.69421 14.281 3.76158 13.5934 3.07394C12.9057 2.38631 11.9731 2 11.0007 2C9.82732 2 9.00065 2.33333 8.00065 3.33333C7.00065 2.33333 6.17398 2 5.00065 2C4.02819 2 3.09556 2.38631 2.40793 3.07394C1.72029 3.76158 1.33398 4.69421 1.33398 5.66667C1.33398 7.2 2.33398 8.36667 3.33398 9.33333L8.00065 14L12.6673 9.33333Z"
          stroke="#696B6D"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.00039 3.3335L6.02706 5.30683C5.89161 5.4413 5.7841 5.60124 5.71074 5.77745C5.63738 5.95365 5.59961 6.14263 5.59961 6.3335C5.59961 6.52436 5.63738 6.71334 5.71074 6.88954C5.7841 7.06575 5.89161 7.22569 6.02706 7.36016C6.57373 7.90683 7.44706 7.92683 8.02706 7.40683L9.40706 6.14016C9.75296 5.82629 10.2033 5.65242 10.6704 5.65242C11.1375 5.65242 11.5878 5.82629 11.9337 6.14016L13.9071 7.9135"
          stroke="#696B6D"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.0003 9.99984L10.667 8.6665"
          stroke="#696B6D"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.0003 11.9998L8.66699 10.6665"
          stroke="#696B6D"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2939_9142">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.000488281)"
          />
        </clipPath>
      </defs>
    </svg>
  );
});

HeartHandIcon.displayName = "HeartHandIcon";
